import AnswerItem from "./AnswerItem";
import { Answer } from "../../types/Answer";
import { Question } from "../../types/Question";

import Stack from "@mui/material/Stack";
import React from "react";

interface AnswersListProps {
    answers: Answer[];
    question: Question;
}

const AnswersList: React.FC<AnswersListProps> = ({ answers, question }) => {
    return (
        <Stack direction={"column"} spacing={3}>
            {answers.map((answer) => (
                <AnswerItem answer={answer} question={question} key={answer.id} />
            ))}
        </Stack>
    );
};

export default AnswersList;
